var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoitering(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 8,
    fill: "#E2FCFD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8151 23.3332L16.2225 20.9628L15.0374 19.185V15.6295M15.0374 15.6295L12.667 17.4072L13.2596 18.5924M15.0374 15.6295L16.8151 16.8147L18.0003 17.1109M14.4448 20.9628L13.2596 23.3332M14.4448 13.2591C14.4448 13.4163 14.5072 13.567 14.6183 13.6781C14.7295 13.7893 14.8802 13.8517 15.0374 13.8517C15.1945 13.8517 15.3453 13.7893 15.4564 13.6781C15.5675 13.567 15.63 13.4163 15.63 13.2591C15.63 13.1019 15.5675 12.9512 15.4564 12.8401C15.3453 12.7289 15.1945 12.6665 15.0374 12.6665C14.8802 12.6665 14.7295 12.7289 14.6183 12.8401C14.5072 12.9512 14.4448 13.1019 14.4448 13.2591Z",
    stroke: "#017C84",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1481 23.3332L21.5556 20.9628L20.3704 19.185V15.6295M20.3704 15.6295L18 17.4072L18.5926 18.5924M20.3704 15.6295L22.1481 16.8147L23.3333 17.1109M19.7778 20.9628L18.5926 23.3332M19.7778 13.2591C19.7778 13.4163 19.8402 13.567 19.9513 13.6781C20.0625 13.7893 20.2132 13.8517 20.3704 13.8517C20.5275 13.8517 20.6783 13.7893 20.7894 13.6781C20.9005 13.567 20.963 13.4163 20.963 13.2591C20.963 13.1019 20.9005 12.9512 20.7894 12.8401C20.6783 12.7289 20.5275 12.6665 20.3704 12.6665C20.2132 12.6665 20.0625 12.7289 19.9513 12.8401C19.8402 12.9512 19.7778 13.1019 19.7778 13.2591Z",
    stroke: "#017C84",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoitering);
export default __webpack_public_path__ + "static/media/Loitering.85da6979165410c5ad8f4e226ae7cc05.svg";
export { ForwardRef as ReactComponent };